export function getPerformaceYearsCollection(): PerformanceYear[] {
  const minYear = 2026;
  const maxYear = 2126;

  const collectionToBeSavedForLegacy = [
    { id: 11, title: '2025' },
    { id: 1, title: '2024' },
    { id: 2, title: '2023' },
    { id: 3, title: '2022' },
    { id: 4, title: '2021' },
    { id: 5, title: '2020' },
    { id: 6, title: '2019' },
    { id: 7, title: '2018' },
    { id: 8, title: '2017' },
    { id: 9, title: '2016' },
    { id: 10, title: '2015' }
  ];

  const masterCollection: PerformanceYear[] =
    collectionToBeSavedForLegacy.concat(
      Array.from({ length: maxYear - minYear + 1 }, (_, index) => {
        const year = minYear + index;
        return { id: year, title: String(year) };
      })
    );

  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 11;
  const endYear = currentYear - 1;

  let collectionToBeReturned = masterCollection
    .filter(item => +item.title >= startYear && +item.title <= endYear)
    .sort((a, b) => +b.title - +a.title);

  return collectionToBeReturned;
}

export interface PerformanceYear {
  id: number;
  title: string;
}
